import React from 'react';

const PageNumberButton = ({ pageNumber, isSelected, onClick }) => {
    const handleClick = () => {
        console.log(`📄 PageNumberButton clicked: ${pageNumber}`);
        onClick(pageNumber);
    };

    return (
        <button
            onClick={handleClick}
            title={`Go to page ${pageNumber}`}
            disabled={isSelected}
            className={`
                flex items-center justify-center min-w-[32px] sm:min-w-[40px] h-8 sm:h-10 px-2 sm:px-3 rounded-lg font-semibold text-xs sm:text-sm transition-all duration-200
                ${isSelected
                    ? 'bg-gradient-to-r from-[#247E45] to-[#026B33] text-white shadow-lg shadow-emerald-500/30 scale-105 cursor-default'
                    : 'bg-white border border-slate-200 text-slate-700 hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 hover:border-emerald-200 hover:text-[#247E45] hover:shadow-md cursor-pointer'
                }
            `}
        >
            {pageNumber}
        </button>
    );
};

export default PageNumberButton;
